﻿/**
 * re-languagespoken-data
 * @module languageSpokenData
 * @author May Montazer
 */

define([], function() {
    'use strict';

    var data = [
        { label: 'English', value: 'en-GB,en-US,en-UD' },
        { label: 'Spanish', value: 'es-LA,es-ES' },
        { label: 'Chinese (Cantonese)', value: 'zh-HK,zh-Hans,zh-Hant' },
        { label: 'Chinese (Mandarin)', value: 'zh-CN,zh-TW,zh-Hans,zh-Hant' },
        { label: 'French', value: 'fr-CA,fr-FR' },
        { label: 'Tagalog', value: 'tl-PH,fil-PH' },
        { label: 'Afrikaans', value: 'af-ZA' },
        { label: 'Albanian', value: 'sq-AL' },
        { label: 'Amharic', value: 'am-ET' },
        { label: 'Arabic', value: 'ar-AR' },
        { label: 'Armenian', value: 'hy-AM' },
        { label: 'Assamese', value: 'as-IN' },
        { label: 'Azerbaijani', value: 'az-AZ' },
        { label: 'Basque', value: 'eu-ES' },
        { label: 'Belarusian', value: 'be-BY' },
        { label: 'Bengali', value: 'bn-IN' },
        { label: 'Bosnian', value: 'bs-BA' },
        { label: 'Breton', value: 'br-FR' },
        { label: 'Bulgarian', value: 'bg-BG' },
        { label: 'Burmese', value: 'my-MM' },
        { label: 'Catalan', value: 'ca-ES' },
        { label: 'Cherokee', value: 'chr-US' },
        { label: 'Cebuano', value: 'cx-PH' },
        { label: 'Corsican', value: 'co-FR' },
        { label: 'Cree', value: 'cr-CA' },
        { label: 'Croatian', value: 'hr-HR' },
        { label: 'Czech', value: 'cs-CZ' },
        { label: 'Danish', value: 'da-DK' },
        { label: 'Dutch', value: 'nl-NL,nl-BE' },
        { label: 'Esperanto', value: 'eo-EO' },
        { label: 'Estonian', value: 'et-EE' },
        { label: 'Faroese', value: 'fo-FO' },
        { label: 'Finnish', value: 'fi-FI' },
        { label: 'Frisian', value: 'fy-NL' },
        { label: 'Fulah', value: 'ff-NG' },
        { label: 'Gaelic', value: 'gd-GB' },
        { label: 'Galician', value: 'gl-ES' },
        { label: 'Georgian', value: 'ka-GE' },
        { label: 'Guarani', value: 'gn-PY' },
        { label: 'German', value: 'de-DE' },
        { label: 'Greek', value: 'el-GR' },
        { label: 'Gujarati', value: 'gu-IN' },
        { label: 'Haitian Creole', value: 'ht-HT' },
        { label: 'Hakha Chin', value: 'cnh-MM' },
        { label: 'Hausa', value: 'ha-NG' },
        { label: 'Hebrew', value: 'he-IL' },
        { label: 'Hindi', value: 'hi-IN' },
        { label: 'Hungarian', value: 'hu-HU' },
        { label: 'Hmong (Laos)', value: 'hmn-LA'},
        { label: 'Icelandic', value: 'is-IS' },
        { label: 'Igbo', value: 'ig-NG' },
        { label: 'Indonesian', value: 'id-ID' },
        { label: 'Irish', value: 'ga-IE' },
        { label: 'Italian', value: 'it-IT' },
        { label: 'Japanese', value: 'ja-JP,ja-KS' },
        { label: 'Javanese', value: 'jv-ID' },
        { label: 'Kannada', value: 'kn-IN' },
        { label: 'Kazakh', value: 'kk-KZ' },
        { label: 'Khmer', value: 'km-KH' },
        { label: 'Kinyarwanda', value: 'rw-RW' },
        { label: 'Korean', value: 'ko-KR' },
        { label: 'Kurdish (Kurmanji)', value: 'ku-TR' },
        { label: 'Kurdish (Sorani)', value: 'cb-IQ' },
        { label: 'Kutchi', value: 'kut-IN' },
        { label: 'Kyrgyz', value: 'ky-KG' },
        { label: 'Lao', value: 'lo-LA' },
        { label: 'Latvian', value: 'lv-LV' },
        { label: 'Lithuanian', value: 'lt-LT' },
        { label: 'Luxemburgish', value: 'lb-LU' },
        { label: 'Macedonian', value: 'mk-MK' },
        { label: 'Malagasy', value: 'mg-MG' },
        { label: 'Malay', value: 'ms-MY' },
        { label: 'Malayalam', value: 'ml-IN' },
        { label: 'Maltese', value: 'mt-MT' },
        { label: 'Marathi', value: 'mr-IN' },
        { label: 'Mongolian', value: 'mn-MN' },
        { label: 'Navajo', value: 'nv-US' },
        { label: 'Nepali', value: 'ne-NP' },
        { label: 'Norwegian', value: 'nn-NO,nb-NO' },
        { label: 'Ojibwa', value: 'oj-CA' },
        { label: 'Odia', value: 'or-IN' },
        { label: 'Pashto', value: 'ps-AF' },
        { label: 'Persian', value: 'fa-IR' },
        { label: 'Polish', value: 'pl-PL' },
        { label: 'Portuguese', value: 'pt-PT,pt-BR' },
        { label: 'Punjabi', value: 'pa-IN' },
        { label: 'Romanian', value: 'ro-RO' },
        { label: 'Russian', value: 'ru-RU' },
        { label: 'Serbian', value: 'sr-RS' },
        { label: 'Shanghainese', value: 'wuu-CN' },
        { label: 'Shona', value: 'sn-ZW' },
        { label: 'Sign Language', value: 'sgn-US' },
        { label: 'Silesian', value: 'sz-PL' },
        { label: 'Sindhi', value: 'sd-PK' },
        { label: 'Sinhala', value: 'si-LK' },
        { label: 'Slovak', value: 'sk-SK' },
        { label: 'Slovenian', value: 'sl-SI' },
        { label: 'Somali', value: 'so-SO' },
        { label: 'Sotho', value: 'st-ZA' },
        { label: 'Swahili', value: 'sw-KE' },
        { label: 'Swati', value: 'ss-SZ' },
        { label: 'Swedish', value: 'sv-SE' },
        { label: 'Syrian', value: 'sy-SY' },
        { label: 'Taiwanese', value: 'nan-TW' },
        { label: 'Tajik', value: 'tg-TJ' },
        { label: 'Tamil', value: 'ta-IN' },
        { label: 'Tamazight', value: 'tz-MA' },
        { label: 'Tatar', value: 'tt-RU' },
        { label: 'Telugu', value: 'te-IN' },
        { label: 'Thai', value: 'th-TH' },
        { label: 'Tigrinya', value: 'ti-ER' },
        { label: 'Turkish', value: 'tr-TR' },
        { label: 'Ukrainian', value: 'uk-UA' },
        { label: 'Urdu', value: 'ur-PK' },
        { label: 'Uzbek', value: 'uz-UZ' },
        { label: 'Vietnamese', value: 'vi-VN' },
        { label: 'Welsh', value: 'cy-GB' },
        { label: 'Xhosa', value: 'xh-ZA' },
        { label: 'Yiddish', value: 'yi-US' },
        { label: 'Yoruba', value: 'yo-NG' },
        { label: 'Zaza', value: 'zz-TR' },
        { label: 'Zulu', value: 'zu-ZA' }
    ];

    var module = {
        browse: function () {
            return data;
        }
    };

    return module;
});
